// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mat-icon {\n  width: 12px !important;\n  height: 12px !important;\n  font-size: 12px !important;\n  margin-right: 11px;\n}\n\n.line-report {\n  padding-top: 5px;\n  padding-bottom: 5px;\n  font-weight: 200;\n}\n\n#performance-report {\n  margin-top: -10px;\n  margin-bottom: 10px;\n  line-height: 14px;\n  font-size: 12px;\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
